import { URL_GET_MENU } from 'constants/urls';

/**
 * @async
 * @function getMenuApi
 * @returns { Promise<Object> }
 */
async function getMenuApi() {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_MENU, options);

	if (!res.ok) {
		const message = `HTTP error! status message: ${res.statusText}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
}

export default getMenuApi;
